import './Festival.scss';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'; // Hindu Festivals
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';       // Top 10 Festivals
import TempleBuddhistOutlinedIcon from '@mui/icons-material/TempleBuddhistOutlined'; // Tamil Festivals
import FilterVintageOutlinedIcon from '@mui/icons-material/FilterVintageOutlined';   // Malayalam Festivals
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';               // Sankranti Festivals
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined'; // Dashavatra
import WhatshotOutlinedIcon from '@mui/icons-material/WhatshotOutlined';             // Navdurga
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';             // Puja Vidhi
import SelfImprovementOutlinedIcon from '@mui/icons-material/SelfImprovementOutlined'; // Hindu Deities
import EmojiPeopleOutlinedIcon from '@mui/icons-material/EmojiPeopleOutlined';       // Gurus and Saints
import AdjustOutlinedIcon from '@mui/icons-material/AdjustOutlined';                 // 24 Vishnu Avatar

import { Link } from 'react-router-dom';

const Festivals = ({ onClose }) => {
  return (
    <div className="Festivals-modal-overlay" onClick={onClose}>
      <div className="Festivals-modal-content" onClick={e => e.stopPropagation()}>
        <div className="festivals-container">
          <h2>Festivals</h2>
          <div className="festivals-grid">

            <Link to="/festival/hindufest" className="festival-item">
              <EventAvailableOutlinedIcon className="icon" />
              <h4>Hindu Festivals</h4>
            </Link>

            <Link to="/festival/top10" className="festival-item">
              <EmojiEventsOutlinedIcon className="icon" />
              <h4>Top 10 Festivals</h4>
            </Link>

            <Link to="/festival/tamil" className="festival-item">
              <TempleBuddhistOutlinedIcon className="icon" />
              <h4>Tamil Festivals</h4>
            </Link>

            <Link to="/festival/malayalam" className="festival-item">
              <FilterVintageOutlinedIcon className="icon" />
              <h4>Malyalam Festivals</h4>
            </Link>

            <Link to="/festival/sankranti" className="festival-item">
              <WbSunnyOutlinedIcon className="icon" />
              <h4>Sankranti Festivals</h4>
            </Link>

            <Link to="/festival/dashavatra" className="festival-item">
              <AutoAwesomeMosaicOutlinedIcon className="icon" />
              <h4>Dashavatra</h4>
            </Link>

            <Link to="/festival/navdurga" className="festival-item">
              <WhatshotOutlinedIcon className="icon" />
              <h4>Navdurga</h4>
            </Link>

            <Link to="/festival/puja-vidhi" className="festival-item">
              <MenuBookOutlinedIcon className="icon" />
              <h4>Puja Vidhi</h4>
            </Link>

            <Link to="/festival/deities" className="festival-item">
              <SelfImprovementOutlinedIcon className="icon" />
              <h4>Hindu Deities</h4>
            </Link>

            <Link to="/festival/gurus-saints" className="festival-item">
              <EmojiPeopleOutlinedIcon className="icon" />
              <h4>Gurus and Saints</h4>
            </Link>

            <Link to="/festival/vishnu-avatar" className="festival-item">
              <AdjustOutlinedIcon className="icon" />
              <h4>24 Vishnu Avatar</h4>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Festivals;
